// ----------------
// LOCAL - No domain
// ----------------
import { config } from './config';

// ---------------------
// External

const basePath = config.CLIENT_URL;

const Redirections = {

    // BASE ROUTES
    ROUTE_LINK_HOME: {
        partial: `/`,
        full: `${basePath}/`
    },
    ROUTE_LINK_PRIVACY_POLICY: {
        partial: '/privacy',
        full: `${basePath}/privacy`
    },
    ROUTE_LINK_TERMS: {
        partial: '/terms',
        full: `${basePath}/terms`
    },
    ROUTE_LINK_ENGAGE_NOBLEOAK: {
        partial: '/engage/nobleoak/557340',
        full: `${basePath}/engage/nobleoak/557340`
    },
}

export default Redirections;